import React from 'react';

const withProps = (WrappedComponent, adittionalProps) => {
  function WithProps(props) {
    return <WrappedComponent {...adittionalProps} {...props} />;
  }
  WithProps.displayName = `withProps(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return WithProps;
};

export default withProps;
